import { useCallback } from "react";
import type { RefObject } from "react";
import { ApiError, api } from "./session-api";
import type { ProfileSync } from "./profile-sync";

export function useFeedback(
  token: RefObject<string>,
  sync: ProfileSync,
  setNotice: (message: string) => void,
  unauthorized: (message: string) => void,
) {
  return useCallback(
    async (text: string, rating: number) => {
      const ticket = sync.ticket();
      try {
        await api.feedback(token.current, text, rating);
        if (ticket === sync.ticket())
          setNotice(
            "Отзыв отправлен. Спасибо!",
          );
      } catch (error) {
        if (
          ticket === sync.ticket() &&
          error instanceof ApiError &&
          error.status === 401
        )
          unauthorized("Сессия истекла. Войди снова.");
        throw error;
      }
    },
    [token, sync, setNotice, unauthorized],
  );
}
